
import CardRh from "@/components/cards/ManzaCard.vue";
import PerfilService from "@/service/v1/seguranca/PerfilService";
import { Options, Vue } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { Watch, Prop } from 'vue-property-decorator';
import Permissao from "./_Permissao.vue";
import Usuario from "./_Usuarios.vue";
import Cadastro from "./_Cadastro.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Pdf from "./_Pdf.vue";
import { namespace } from 'vuex-class';
const authStore = namespace('auth');

@Options({
    name: "Afastamento",
    components: { CardRh, KDataTable, Permissao, Usuario, Cadastro, Pdf },
})
export default class Afastamento extends Vue {

    @authStore.Getter
    public token!: any

    @Prop() readonly model_watch!: any
    @Prop() readonly modal_cadastro!: any
    @Prop() readonly perfis!: any

    @Watch('model_watch')
    modeloAlterado(newVal: string) {
        this.reloadDatatable = !this.reloadDatatable;
    }

    public processando = false;
    public modelo = null;
    public dados = null;
    public reloadDatatable = false;
    public config;
    public service;
    public modal_usuario;
    public modal_permissao;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: {}, columnDefs: {} };
        this.service = new PerfilService();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value
                };
                return dados;
            }
        };

        this.modal_usuario = 'modal_perfil_usuario_';
        this.modal_permissao = 'modal_perfil_permissao_';
        this.config.columns = [
            { data: 'id', name: 'id' },
            { data: 'nome', name: 'nome' },
            { data: 'descricao', name: 'descricao' }
        ];
        if (this.hasPermissao) {
            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs = [
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) { buttom = buttom + ' data-' + key + '="' + val[key] + '"'; }
                        texto = texto + '<button class="btn btn-warning btn-sm" btn-usuario ' + buttom + '   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_usuario + '"><i class="fa fa-users"></i></button>';
                        return texto;
                    },
                }
            ];
        }
    }

    public tableatualizada() {
        $('[btn-usuario]').click((btn) => {
            this.modelo = $(btn.currentTarget).data();
        });
        $('[btn-permissao]').click((btn) => {
            this.dados = $(btn.currentTarget).data();
        });
    }
}
